// extracted by mini-css-extract-plugin
var _1 = "RequestArchivedPipelinesModalTableRow-moduleRequestArchivedPipelinesModalTableRow__N7eKR TableComponent-modulerow__xPAo4";
export { _1 as "RequestArchivedPipelinesModalTableRow" }
